import React from 'react'
import {call, put, take, takeLatest} from 'redux-saga/effects'

import * as addToLookActions from '../actions/addToLook'
import * as modalActions from '../actions/modal'

import * as track from '../track/track'

import AddToNewLookPanel from '../components/Dashboard/Outfits/LookNamePanel/AddToNewLookPanel'

/**
 * Saga which handles opening the look name panel modal and adding product(s) to a new look after the user
 * selects a look name from the look name panel.
 *
 * @param products {Object|Object[]} A single product or array or product objects
 * @param origin {String} Determines the original source of where user initiated flow (for analytics purposes)
 * @generator
 */
export function* openLookNamePanelWorker({payload: {products, origin}}) {
  yield call(track.lookNameModalViewed)
  yield put(modalActions.openSlidingModal(<AddToNewLookPanel />))

  // TODO: ideally the logic for adding products from the look panel below can be separated, but, this requires
  //       us to refactor the addToNewLook thunk as well which requires a significant refactor of a number of other
  //       dependent thunks
  const {type, payload} = yield take([
    modalActions.ADD_LOOK_FOR_SELECTED_LOOK_NAME,
    modalActions.CLOSE_SLIDING_MODAL,
  ])
  if (type === modalActions.CLOSE_SLIDING_MODAL) {
    yield put(addToLookActions.addToLookIdle())
    return
  }
  yield put(addToLookActions.addProductsToNewLook(payload.lookName, products, origin))
}

export function* openLookNamePanelSaga() {
  yield takeLatest(modalActions.OPEN_LOOK_NAME_PANEL, openLookNamePanelWorker)
}
